import React, { memo } from 'react';
import { Cell, Row, Button, Tag } from '@dexma/ui-components';

import gtmIds from 'adapter/in/dashboards/config/gtm';
import { StyledDashboardLinkHeader, StyledTagGroupHeader } from 'adapter/in/dashboards/pages/DashboardLink/Header/style';
import i18n from 'asset/translation';

export type DashboardLinkHeaderType = {
    name: string;
    tags: { label: string; icon: string }[];
    onFullscreen: () => void;
    fullscreenActive: boolean;
    isLandscape: boolean;
};

const DashboardLinkHeader = memo((props: DashboardLinkHeaderType) => {
    const { name, tags, onFullscreen, fullscreenActive, isLandscape } = props;
    return (
        <StyledDashboardLinkHeader $isLandscape={isLandscape}>
            <Cell>
                <Row>
                    <Cell className={isLandscape ? 'fit' : undefined} xs={isLandscape ? undefined : 12}>
                        <h2 className='name'>{name}</h2>
                    </Cell>
                    <Cell>
                        <Row className='baseline'>
                            <Cell>
                                <StyledTagGroupHeader>
                                    {tags.map((tag, id) => (
                                        <Tag key={id} variant='outline' color='gray500' icon={tag.icon}>
                                            {tag.label}
                                        </Tag>
                                    ))}
                                </StyledTagGroupHeader>
                            </Cell>
                        </Row>
                    </Cell>
                </Row>
            </Cell>
            {!fullscreenActive && (
                <Cell className='fit'>
                    <Button
                        kind='iconButton'
                        data-testid='fullscreen-button'
                        iconAfter='fullscreen'
                        variant='icon-secondary'
                        isCircle
                        onClick={onFullscreen}
                        dataId={gtmIds.dashboardLink.actions.fullscreen}
                        iconAriaLabel={i18n.t('dashboards.ariaLabel.fullScreenIcon')}
                    />
                </Cell>
            )}
        </StyledDashboardLinkHeader>
    );
});

export default DashboardLinkHeader;
